var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeleteTrashFilled = function SvgDeleteTrashFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 3.7v-.475h3.5V3.7h-3.5Zm-1.5 0v-.808c0-.648.52-1.167 1.167-1.167h4.166c.648 0 1.167.52 1.167 1.167V3.7h3.833a.75.75 0 0 1 0 1.5h-.5v11.875c0 .664-.535 1.2-1.2 1.2H4.617c-.665 0-1.2-.536-1.2-1.2V5.2h-.5a.75.75 0 1 1 0-1.5H6.75Zm5.864 5.814a.75.75 0 1 0-1.061-1.061L10 10.006 8.447 8.453a.75.75 0 1 0-1.06 1.06l1.552 1.554-1.553 1.553a.75.75 0 1 0 1.061 1.06L10 12.127l1.553 1.553a.75.75 0 0 0 1.06-1.06l-1.552-1.553 1.553-1.553Z",
    fill: "current"
  })));
};
export default SvgDeleteTrashFilled;